import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import ContactPicker from '../components/ContactPicker';
import TagPicker from '../components/TagPicker';
import {api} from '../../api';


export default function EditDeal() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [form, setForm] = useState(null);

  useEffect(() => {
    api(`/companies`).then(r => r.json()).then(setCompanies).catch(() => {});
    api(`/deals/${id}`).then(r => r.json()).then(d => {
      setForm({ name: d.name, companyId: d.companyId || '', value: d.value != null ? d.value : '', stage: d.stage, closeDate: d.closeDate || '' });
      setSelectedContacts((d.contacts || []).map(c => ({ id: c.id, firstName: c.firstName, lastName: c.lastName })));
      setSelectedTags((d.tags || []).map(t => ({ id: t.id, name: t.name })));
    });
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      ...form,
      value: form.value !== '' ? parseFloat(form.value) : null,
      companyId: form.companyId || null,
      contactIds: selectedContacts.map(c => c.id),
      tagIds: selectedTags.map(t => t.id),
      closeDate: form.closeDate || null
    };
    const res = await api(`/deals/${id}`, { method: 'PUT', body: JSON.stringify(body) });
    if (res.ok) navigate(`/crm/deals/${id}`);
  };

  if (!form) return null;

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow p-6 max-w-2xl">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Edit Deal</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
            <input type="text" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Company</label>
            <select value={form.companyId} onChange={(e) => setForm({...form, companyId: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600">
              <option value="">No company</option>
              {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Value</label>
            <input type="number" step="0.01" value={form.value} onChange={(e) => setForm({...form, value: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Stage *</label>
            <select value={form.stage} onChange={(e) => setForm({...form, stage: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600">
              <option value="DISCOVERY">Discovery</option>
              <option value="QUALIFIED">Qualified</option>
              <option value="PROPOSAL">Proposal</option>
              <option value="NEGOTIATION">Negotiation</option>
              <option value="CLOSED_WON">Closed Won</option>
              <option value="CLOSED_LOST">Closed Lost</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Contacts</label>
            <ContactPicker selected={selectedContacts} onChange={setSelectedContacts} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Tags</label>
            <TagPicker selected={selectedTags} onChange={setSelectedTags} />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Close Date</label>
            <input type="date" value={form.closeDate} onChange={(e) => setForm({...form, closeDate: e.target.value})} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" />
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <button type="button" onClick={() => navigate(`/crm/deals/${id}`)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Save</button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
